/**
 * Canonical source of truth for artist discography sort options.
 */

import { z } from "zod";

export const DISCOGRAPHY_SORTS = ["popular", "oldest", "newest", "az", "za"] as const;
export const discographySortEnum = z.enum(DISCOGRAPHY_SORTS);
export type DiscographySort = z.infer<typeof discographySortEnum>;
